import { InfoCircledIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrelViewerContext } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC } from 'react'

export const InfoButton: FC = () => {
  const { infoOpen, setInfoOpen } = useKestrelViewerContext()

  return (
    <TooltipWrapper side={'right'} offset={5} label={'Flight Information'}>
      <ViewToggle
        onClick={() => {
          setInfoOpen(!infoOpen)
        }}>
        <InfoCircledIcon style={{ color: 'white' }} width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
